import React from "react";
import "./Boxes.css";


function Boxes(props) {
    return(
        <div className= {props.className}>
            <table>
                <tbody>
                    <tr>
                    <td className = "Box">
                        <div >
                        <p> {props.title}</p>

                        <hr className = "Line" width="20%" color="yellow"/>  
                        <p> {props.subtitle}</p>
                        </div>
                    </td>
                    <td  className = "Box">
                        <div >
                        <p>{props.title2}</p>

                        <hr  className = "Line" width="20%" color="yellow"/>  
                        <p> {props.subtitle2}</p>
                        </div>
                    </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default Boxes;